import React, { Component, ReactElement } from "react";
import { FormattedMessage } from "react-intl";

const ProductWasSuggestedMessage = () => {
  return (
    <TimedRender ms={5000}>
      {(expired) => {
        if (expired) {
          return null;
        }

        return (
          <p
            css={{
              fontSize: 12,
              fontWeight: "normal",
              color: "#21926a",
            }}
          >
            <FormattedMessage defaultMessage="Thanks for the suggestion!" id="3gYDNc" />
          </p>
        );
      }}
    </TimedRender>
  );
};

interface ITimedRenderProps {
  children: (expired: boolean) => ReactElement | null;
  ms: number;
}

interface ITimedRenderState {
  expired: boolean;
}

class TimedRender extends Component<ITimedRenderProps, ITimedRenderState> {
  constructor(props: ITimedRenderProps) {
    super(props);

    this.timeout = setTimeout(() => {
      this.setState({
        expired: true,
      });
    }, this.props.ms);
  }

  state = {
    expired: false,
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  timeout: NodeJS.Timeout;

  render() {
    return this.props.children(this.state.expired);
  }
}

export default ProductWasSuggestedMessage;
